import _ from 'lodash';
import React, { Component } from 'react';
import ProjectCard from './ProjectCard';
import MapContainer3 from '../Maps/MapContainer3.js';
import MapFilter from '../Filters/MapFilter.js';
import './Projects.css';
import { GOOGLE_API_KEY } from '../../environment';
import Header from '../Header/Header';
// import Footer from '../Footer/Footer';
import { connect } from 'react-redux';
import * as actions from '../../actions';

class Projects extends Component {

    componentDidMount() {
        /**
         * parse a list of filters and extract categoryId's
         */
        var categories = [];
        if (this.props.filters.filters.length <= 0) {
            categories = _.map(this.props.filters.categories, 'categoryId');
        } else {
            categories = _.map(this.props.filters.filters, 'categoryId');
        }
        const values = {
            type : [
                "donate"
            ],
            categories : categories
        }
        this.props.filteredSearch(values);
    }

	renderProjectCards(projects) {
		if (projects) {
			return (
				projects.map((project) => (
                    <div key={project._id} className="projects-map-card">
                        <ProjectCard project={project} key={project.projectId} />
                    </div>
                ))
			)
		} else {
            return (
                <span>No projects found</span>
            )
        }
    }

    render () {
        const { filters, auth } = this.props;
        const googleMapURL = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_API_KEY}&v=3.exp&libraries=geometry,drawing,places`;
        return (
            <div>
                <Header auth={auth} />
                <MapFilter />
                <div className="projects-map-container">
                    <div className="projects-map-cards tikki-list-container">
                        {this.renderProjectCards(filters.projects)}
                    </div>
                    <div className="projects-map">
                        <MapContainer3
                            mapMarkers={filters.markers}
                            googleMapURL={googleMapURL}
                            containerElement={<div style={{ width: "100%", height: "100%" }} />}
                            mapElement={<div style={{ height: `100%` }} />}
                            loadingElement={<div style={{ height: `100%` }} />}
                        />
                    </div>
                </div>
                {/* <div className="projects-map-footer tikki-shadow-flat" /> */}
                {/* <Footer /> */}
            </div>
        );
    };
};

function mapStateToProps({ filters }) {
    return { filters };
}

export default connect(mapStateToProps, actions)(Projects);



// WEBPACK FOOTER //
// ./src/components/Projects/Projects.js